<div class="activity-information">
	<div class="info-card">
		<div class="wrapper">
			<section
				class="content-grid">
				<button
					type="button"
					*ngIf="shouldShowActivityPicture()"
					data-cy="activity-type-name"
					class="btn-none"
					(click)="showActivityPicture()">
					{{ getActivityTypeName() }}
				</button>
				<span *ngIf="!shouldShowActivityPicture()">
					{{ getActivityTypeName() }}
				</span>

				<button
					type="button"
					*ngIf="activity.isViewable('rubric_template_id') && isRubricEnabled()"
					class="btn-none preview-rubric"
					(click)="previewRubric()"
					translate="activity-view_setting-indicator-preview-rubric">
				</button>

				<button
					type="button"
					*ngIf="markerSet"
					class="btn-none preview-marker-set"
					(click)="previewMarkerSet()"
					translate="activity-view_setting-indicator-preview-marker-set">
				</button>

				<button
					type="button"
					*ngIf="shouldSeePreviewAiMarkers()"
					class="btn-none preview-ai-markers"
					(click)="previewAiMarkers()"
					translate="activity-view_setting-indicator-preview-ai-markers">
				</button>

				<span
					tabindex="0"
					translate="{{activity.isViewable('has_single_recording_attempt') && activity.has_single_recording_attempt ? 'activity-info_single-attempt' : 'activity-info_unlimited-attempts'}}">
				</span>

				<span
					*ngIf="activity.isViewable('time_limit') && activity.time_limit != null"
					tabindex="0"
					translate="{{ 'activity-view_time-limit-description' | translate: { value: activity.time_limit } }}">
				</span>

				<span
					*ngIf="activity.total_score"
					class="activity-points"
					data-cy="total-points"
					tabindex="0"
					[translateParams]="{ points: activity.total_score }"
					translate="activity-view_points">
				</span>
			</section>
		</div>
	</div>

	<div *ngIf="somethingToShow()">
		<div *ngIf="hideRecordingInstructions" class="info-card">
			<div class="wrapper">
				<h5 translate="activity-info_recording-instructions"></h5>
				<span translate="activity-info_section-stimulus-available"></span>
			</div>
		</div>

		<rich-instructions
			*ngIf="showInstructions('recording')"
			[instruction]="activity.recording_instructions">
		</rich-instructions>

		<rich-instructions
			*ngIf="showInstructions('feedback')"
			[instruction]="activity.feedback_instructions">
		</rich-instructions>

		<media-card
			*ngIf="showSourceMedia() && isOnDashboard"
			class="source-media"
			[label]="'assignment-information-stimulus-title'"
			[media]="activity.source_media.media">
		</media-card>

		<div *ngIf="showAttachments()" class="info-card card-attachments" >
			<div class="wrapper">
				<h5 translate="activity-info_activity-resources"></h5>
				<ng-container *ngIf="!hideSourceMedia">
					<media-card
						*ngFor="let attachment of activity.attachments"
						class="attachment-media"
						[media]="attachment.media">
					</media-card>
				</ng-container>
				<section
					*ngIf="hideSourceMedia"
					translate="activity-info_section-resources-available">
				</section>
			</div>
		</div>
	</div>

	<div *ngIf="!somethingToShow() && isOnDashboard"
		class="no-information"
		translate="assignment-information-no-instructions">
	</div>
</div>
